import ExamDetails from './ExamDetails';

export default ExamDetails;
